import { render, staticRenderFns } from "./ExperteDetails.vue?vue&type=template&id=22e456df&scoped=true&"
import script from "./ExperteDetails.vue?vue&type=script&lang=js&"
export * from "./ExperteDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExperteDetails.vue?vue&type=style&index=0&id=22e456df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e456df",
  null
  
)

export default component.exports